import React from 'react';
import cn from 'classnames';

import './DropArea.scss';

type Props = {
  className?: string;
  isTop?: boolean;
  isBottom?: boolean;
  isDropAsChild?: boolean;
};

export function DropArea({ className = '', isDropAsChild = false, isTop = false, isBottom = false }: Props) {
  return (
    <div
      className={cn(`drop-area d-flex ${className}`, {
        'drop-area--is-top': isTop,
        'drop-area--is-bottom': isBottom,
        'drop-area--is-drop-as-child': isDropAsChild,
      })}
    >
      <div className="drop-area-content m-auto">Drop here</div>
    </div>
  );
}
